import React, {useState} from 'react';
import Translation from "@Translation/components/Translation";
import {useTranslation} from "@Translation/hooks/useTranslation";
import {reviewTagsBus, reviewTagsFerry} from "@Pages/reviews/constants/reviewTags";
import toggleArrayMember from "../../../utils/array/toggleArrayMember";
import {useSelector} from "react-redux";
import {transportationTypes} from "@Pages/reviews/constants/transportationTypes";
import {capitalize} from "@String/capitalize";

interface ReviewTagsProps {
    tagHandler: (tags: any[]) => void,
    activeTags: any[]
}

function ReviewTags({tagHandler, activeTags}: ReviewTagsProps) {
    const {filter_tags: tags} = useTranslation("place_review")

    const {companyMainTransportType} = useSelector(state => state?.page)

    const reviewTags = companyMainTransportType === transportationTypes.bus ? reviewTagsBus : reviewTagsFerry;



    return (
        <div className="multi-tag__filter">
            <span className="gb--input-label">
                <Translation translationKey="c_profile.company_reviews.multi_tag_filter"/>
            </span>
            <div className="multi-tag__list">
                {reviewTags.map((tag) => {
                    const className = activeTags.includes(tags[tag]) ? 'gb--tag-green' : 'gb--tag-default'
                    return (
                        <button
                            type="button"
                            className={`gb--tag ${className}`}
                            key={tags[tag]}
                            onClick={toggleArrayMember(tagHandler, activeTags, tags[tag])}
                        >
                            {capitalize(tags[tag])}
                        </button>
                    )
                })}
            </div>
        </div>
    );
}

export default ReviewTags